import { BOIType } from "../interfaces";
import { usTerritories } from "./constants";

export const getOwnerType = (
  isEntity: boolean | null,
  boiType: BOIType
) => {
  if (isEntity) {
    return "Entity Owner";
  }
  if (boiType === BOIType.COMPANY_APPLICANT) {
    return "Company Applicant";
  } else {
    return "Beneficial Owner";
  }
};

export const zipCodeRequired = (jurisdiction: string | null): boolean => {
  if (!jurisdiction) return false;
  return (
    jurisdiction === "United States" ||
    jurisdiction === "Canada" ||
    jurisdiction === "Mexico" ||
    usTerritories.includes(jurisdiction)
  );
};
